import * as schemas from "./schemas";

export const STORAGE_KEY = "embersrpgvault";

let sessionSchema = {
  version: 1,
  user: null,
  accessToken: null,
  expiresAt: null,
  redirectUrl: null
};

let initialState = {
  session: sessionSchema,
  alert: {
    type: null,
    title: null,
    message: null
  },
  schemas: {
    actions: schemas.ActionSchemas,
    sheets: schemas.SheetSchemas,
    items: schemas.ItemSchemas,
    notes: schemas.NoteSchemas,
    rules: schemas.RuleSchemas,
    skills: schemas.SkillSchemas,
    spells: schemas.SpellSchemas,
    trackables: schemas.TrackableSchemas
  }
};

/*
{
  route: '/tasks/5'
  method: 'patch'
  data: {
    name: "My task's new name"
  }
}
*/

// Check local storage for our key and retrieve the data, if it exists,
// otherwise use defaults.
if (localStorage.getItem(STORAGE_KEY)) {
  let session = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (session.version !== sessionSchema.version) session = sessionSchema;
  initialState.session = session;
}

export const state = initialState;
